import { P, StyledLink } from "orcs-design-system";
import PropTypes from "prop-types";
import React from "react";

import { searchErrorLabel } from "../Search.config";

/**
 * Renders a no-options message for react-select.
 * Callers supply the params for their use case.
 *
 * @param {object} searchError - When present, shows the error message
 * @param {string} message - Simple message when no link (e.g. "Start typing to search..")
 * @param {string} label - Prefix text when showing a link (e.g. "Not sure what to search for?")
 * @param {object} link - Optional. { url, label, openInNewTab }
 */
const NoOptionsMessage = ({ searchError, message, label, link }) => {
  let content;

  if (searchError) {
    content = searchErrorLabel;
  } else if (link) {
    const linkProps = link.openInNewTab
      ? {
          target: "_blank",
          rel: "noopener noreferrer",
          href: link.url,
        }
      : { to: link.url };
    content = (
      <>
        {label}{" "}
        <StyledLink fontSize="1" {...linkProps}>
          {link.label}
        </StyledLink>
      </>
    );
  } else {
    content = message;
  }

  return (
    <P color="black" fontSize="1">
      {content}
    </P>
  );
};

NoOptionsMessage.propTypes = {
  searchError: PropTypes.object,
  message: PropTypes.string,
  label: PropTypes.string,
  link: PropTypes.shape({
    url: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    openInNewTab: PropTypes.bool,
  }),
};

export default NoOptionsMessage;
